import { render } from "./MessageScroll.vue?vue&type=template&id=5d622e7c&scoped=true"
import script from "./MessageScroll.vue?vue&type=script&lang=js"
export * from "./MessageScroll.vue?vue&type=script&lang=js"

import "./MessageScroll.vue?vue&type=style&index=0&id=5d622e7c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d622e7c"],['__file',"src/views/h5/luqiao/home/MessageScroll.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d622e7c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d622e7c', __exports__)) {
    api.reload('5d622e7c', __exports__)
  }
  
  module.hot.accept("./MessageScroll.vue?vue&type=template&id=5d622e7c&scoped=true", () => {
    api.rerender('5d622e7c', render)
  })

}


export default __exports__